import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Intercept CRM tracking to inject required tags globally
const originalFetch = window.fetch;
window.fetch = async function(...args) {
  if (typeof args[0] === 'string' && args[0].includes('backend.leadconnectorhq.com/external-tracking/events')) {
    try {
      const options = args[1];
      if (options && options.body && typeof options.body === 'string') {
        const payload = JSON.parse(options.body);
        payload.tags = ["form fill", "hot lead"];
        if (payload.formData) {
          payload.formData.tags = "form fill, hot lead";
        }
        options.body = JSON.stringify(payload);
      }
    } catch (e) {
      console.error("Error intercepting CRM fetch:", e);
    }
  }
  return originalFetch.apply(this, args as any);
};

createRoot(document.getElementById("root")!).render(<App />);
